import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingSummary } from '../../models/pcheck.model';

@Component({
  selector: 'app-booking-summary-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './booking-summary-card.component.html',
  styleUrls: ['./booking-summary-card.component.scss'],
})
export class BookingSummaryCardComponent {
  @Input() bookingUrl!: string;
  @Input() summary!: BookingSummary;
  @Input() confirmed = false;
  @Input() recoveryPending = false;
  @Input() recoveryUsed = false;

  @Output() bookingDone            = new EventEmitter<void>();
  @Output() bookingFailed          = new EventEmitter<void>();
  @Output() retrySameExecutive     = new EventEmitter<void>();
  @Output() tryDifferentExecutive  = new EventEmitter<void>();
  @Output() copyValue              = new EventEmitter<{ value: string; label: string }>();

  onCopy(value: string, label: string): void {
    navigator.clipboard.writeText(value).catch(() => {});
    this.copyValue.emit({ value, label });
  }
}
